import { Typography, Table, TableHead, TableCell, TableRow, TableBody } from '@material-ui/core';
import Moment from 'react-moment';
import { ICustomerOrder } from '../TicketPrint';

interface IProps {
    customerOrders: ICustomerOrder[]
}

let ServiceOrders = ({ customerOrders }: IProps) => {
    return (
        <>
            <Typography style={{ marginTop: 16 }} variant="h5">Customer orders</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>M3 Order Number</TableCell>
                        <TableCell>Created By</TableCell>
                        <TableCell>Created On</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {customerOrders?.map(order =>
                        <TableRow key={order.id}>
                            <TableCell>{order.m3OrderNumber}</TableCell>
                            <TableCell>{order.createdBy}</TableCell>
                            <TableCell>
                                <Moment date={order.createdOn} format="ll" />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </>
    )
}

export default ServiceOrders;